import './breadcrumb.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ReactComponent as Arrow } from '../../assets/icons/breadcrumb-arrow.svg';

// The last crumb is the current page, so it renders as plain text.
const ExplicitCrumbs = ({ crumbs }) => (
  <>
    {crumbs.map(({ label, to }, index) => {
      const isLastItem = index + 1 === crumbs.length;

      return (
        <li
          key={`${label}-${index}`}
          className={`breadcrumb__item ${isLastItem ? 'breadcrumb__item--active' : ''}`}
        >
          {isLastItem || !to ? <span>{label}</span> : <Link to={to}>{label}</Link>}
          {!isLastItem && <Arrow />}
        </li>
      );
    })}
  </>
);

// Fallback for routes that declare `breadcrumb: true`.
const PathCrumbs = () => {
  const { pathname } = useLocation();

  // A replace was done to remove the first forward slash to prevent the first item of the array being empty
  const pathsArray = pathname.replace('/', '').split('/');

  const totalNoOfPaths = pathsArray.length;
  let itemLocation = '';

  return pathsArray.map((crumb, index) => {
    const isLastItem = index + 1 === totalNoOfPaths;
    itemLocation += '/' + crumb;

    return (
      <li
        key={`${crumb}-${index}`}
        className={`breadcrumb__item ${isLastItem && 'breadcrumb__item--active'}`}
      >
        <Link to={`${itemLocation}`}>
          {crumb} {!isLastItem && <Arrow />}
        </Link>
      </li>
    );
  });
};

const Breadcrumb = ({ crumbs, variant = '' }) => (
  <nav className={`breadcrumb ${variant}`.trim()} aria-label="Breadcrumb">
    <ul className="breadcrumb__list">
      {crumbs?.length ? <ExplicitCrumbs crumbs={crumbs} /> : <PathCrumbs />}
    </ul>
  </nav>
);

const crumbShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  to: PropTypes.string
});

ExplicitCrumbs.propTypes = { crumbs: PropTypes.arrayOf(crumbShape).isRequired };

Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(crumbShape),
  variant: PropTypes.string
};

export { Breadcrumb };
